module.exports = __webpack_public_path__ + "static/logo-roi-37a4420e2f0fad2c9d1b3439896b33c2.png";